
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { DataGrid } from 'devextreme-react';
import { supplierOrderListService } from '../services/supplier-order-list-service';
import DateBox, { DateBoxTypes } from 'devextreme-react/cjs/date-box';
import { useNavigate } from 'react-router-dom';
import OrderStatusCell from '@/projects/syncflow/order/components/order-status-celll';

const supplierOrderList = () => {

    let startDate = new Date();
    let endDate = new Date();

    let delStartDate = new Date();
    let delEndDate = new Date();

    startDate.setDate(startDate.getDate() - 7);
    delStartDate.setDate(delStartDate.getDate() - 7);

    const dateLabel = { 'aria-label': 'Date' };

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["orderId"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])




    const [productsLookup] = useState(new CustomStore({
        load: supplierOrderListService.getProductsLookups,
        useDefaultSearch: true
    }));

    const [categoriesLookup] = useState(new CustomStore({
        load: supplierOrderListService.getCategoriesLookups,
        useDefaultSearch: true
    }));

    const [accountsLookup] = useState(new CustomStore({
        load: supplierOrderListService.getAccountsLookups,
        useDefaultSearch: true
    }));



    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };


    const navigate = useNavigate();
    const goToDetail = (id: string) => {
        navigate(`/b2b/supplier-order-detail-list/${id}`, { state: { id: id } })
    }

    var RetailerAccountCode: string;
    var productCode: string;
    var productCategoryCode: string;

    const onRetailerAccountCodeChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        RetailerAccountCode = e.value;
    }, []);

    const onProductCodeChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        productCode = e.value;
    }, []);

    const onproductCategoryCodeChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        productCategoryCode = e.value;
    }, []);

    const onValueChangedOrderStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        startDate = e.value;
    }, []);

    const onValueChangedOrderEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        endDate = e.value;
    }, []);

    const onValueChangedDeliveryStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        delStartDate = e.value;
    }, []);

    const onValueChangedDeliveryEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        delEndDate = e.value;
    }, []);



    const onGetOrderData = useCallback(async () => {
        const x = await supplierOrderListService.getOrderList(
            RetailerAccountCode
            , productCode
            , productCategoryCode
            , startDate
            , endDate
            , delStartDate
            , delEndDate
            , typeValue);
        return x;
    }, []);

    const onQuery = useCallback(() => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const orderTypes = [{
        code: "additional_order",
        name: 'Additonal Order',
    },
    {
        code: "ext",
        name: 'Pre Order',
    }
    ];

    var [typeValue, setTypeValue] = useState("");
    const onValueChangedTypes = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setTypeValue(e.value)
        typeValue = e.value;
    }, []);

    const statusColumnRender = (data: any) => (t('syncflow:lb_order_supplier_status_' + data.orderStatusCode));

    return (
        <>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>

                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>
            <div className="row mb-12" style={{ marginBottom: 0 }}>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_customer")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="accountsLookup"
                                dataSource={accountsLookup}
                                valueExpr="code"
                                displayExpr="name"
                                onValueChanged={onRetailerAccountCodeChanged}
                                showClearButton={true}>
                            </SelectBox>
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_type")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="orderTypesLookup"
                                items={orderTypes}
                                onValueChanged={onValueChangedTypes}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>


                <div className="col-lg-6"></div>
                <label className="col-lg-1 col-form-label fw-bold fs-6"> {t("syncflow:lu_order_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={startDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedOrderStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_order_end_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={endDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedOrderEndDate}
                            />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_product")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="productsLookup"
                                dataSource={productsLookup}
                                valueExpr="code"
                                displayExpr="name"
                                onValueChanged={onProductCodeChanged}
                                searchEnabled={true}
                                showClearButton={true}>
                            </SelectBox>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3"></div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_delivery_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={delStartDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedDeliveryStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_delivery_end_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                defaultValue={delEndDate}
                                inputAttr={dateLabel}
                                type="date"
                                onValueChanged={onValueChangedDeliveryEndDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_category")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="categoriesLookup"
                                dataSource={categoriesLookup}
                                valueExpr="code"
                                displayExpr="name"
                                onValueChanged={onproductCategoryCodeChanged}
                                showClearButton={true}>
                            </SelectBox>
                        </div>
                    </div>
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    columnChooser={true}
                    showColumnLines={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'orderTypeCode',
                            caption: "Type",
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return t('syncflow:lb_order_type_' + data.data.orderTypeCode)
                            },
                        },
                        {
                            dataField: 'orderCode',
                            caption: t('syncflow:lb_order_number'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'retailerAccountName',
                            caption: t('syncflow:lb_customer'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'retailerSourceName',
                            caption: t('syncflow:lb_delivery_location'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderDate',
                            caption: t('syncflow:lb_order_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'deliveryDate',
                            caption: t('syncflow:lb_delivery_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'productCount',
                            caption: t('syncflow:lb_product_count'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.orderStatusCode} isAllApproved={account?.orderQty == account?.vendorApprovedQty} label={(account?.productCount + " / " + account?.vendorProductCount)} />
                                )
                            },
                        },
                        {
                            dataField: 'orderQty',
                            caption: t('syncflow:lb_order_quantity') + ' / ' + t('syncflow:lb_supplier_approved_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.orderStatusCode} isAllApproved={account?.orderQty == account?.vendorApprovedQty} label={(account?.orderQty + " / " + account?.vendorApprovedQty)} />
                                )
                            },
                        },
                        {
                            dataField: 'vendorAmount',
                            caption: t('syncflow:lb_order_amount') + ' / ' + t('syncflow:lb_supplier_approved_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.orderStatusCode} isAllApproved={account?.orderQty == account?.vendorApprovedQty} label={("$ " + account?.amount + " / " + "$ " + account?.vendorAmount)} />
                                )
                            },
                        },
                        {
                            dataField: t('orderStatusCode'),
                            caption: t('syncflow:lb_order_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.orderStatusCode} isAllApproved={account?.orderQty == account?.vendorApprovedQty} label={t('syncflow:lb_order_supplier_status_' + account?.orderStatusCode)} ></OrderStatusCell>
                                )
                            },
                        },
                        {
                            caption: t('syncflow:lb_order_detail'),
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:lb_detail")}
                                        type="default"
                                        stylingMode="contained"
                                        icon='showpanel'
                                        onClick={() => goToDetail(data.key.orderId)}
                                    />
                                );
                            },
                        }
                    ]}

                />

            </React.Fragment>

        </>


    )
}
export default supplierOrderList